import { useEffect, useState } from "react";
import "./styles.css";
import AssessmentContainer from "../../Components/AssesmentContainer";
import {
  nextQuestions,
  prevQuestions,
  startNextTestbyCategoryId,
} from "../../Services/Assessment";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useHeader } from "../../Providers/HeaderContextProvider";

function Assessments() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setHeaderContent } = useHeader();
  const categoryId = searchParams.get("categoryId");
  const [isQuestLoading, setisQuestLoading] = useState(false);
  const [isErrorOnProp, setisErrorOnProp] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (isErrorOnProp) setisErrorOnProp(false);
    }, 2000);
  }, [isErrorOnProp]);
  useEffect(() => {
    setHeaderContent(false);
    localStorage.setItem("isEncouragementMessageShown", "true");
    // startQuestions()
    startNextTestbyCategoryId(categoryId, false)
      .then((res) => {
        setcurrentQuestionInfo(res);
      })
      .catch((error) => {});
  }, []);

  const [currentQuestionInfo, setcurrentQuestionInfo] = useState({});
  const [
    numberOfSequentialQuestionanswered,
    setnumberOfSequentialQuestionanswered,
  ] = useState(0);

  //function to submit current question's answer and call next question
  const callNextQuestion = (answer, isExist = false) => {
    if (
      currentQuestionInfo?.categoryId === "" ||
      currentQuestionInfo?.categoryId === undefined ||
      currentQuestionInfo?.categoryId === null ||
      currentQuestionInfo?.currQuestion?.id === "" ||
      currentQuestionInfo?.currQuestion?.id === undefined ||
      currentQuestionInfo?.currQuestion?.id === null
    ) {
      setisErrorOnProp(true);
      return;
    }
    setisQuestLoading(true);
    if (answer.length > 0 || isExist === true) {
      const nextQuestionData = {
        item_id: currentQuestionInfo?.categoryId,
        item_type: "category",
        question_id: currentQuestionInfo?.currQuestion?.id,
        answer_id:
          Array.isArray(answer) && answer.includes(undefined) ? [] : answer,
        skip_question: false,
        exit: isExist ? true : false,
        is_survey: false,
        ques_arr_limit: 10,
      };
      if (
        currentQuestionInfo?.currQuestion?.number ===
        currentQuestionInfo?.totalQuestions
      ) {
        nextQuestions({ ...nextQuestionData, isExist: true })
          .then(async (res) => {
            // setcurrentQuestionInfo();
            if (res?.isLastResponse || res?.nextCategoryId) {
              navigate(`/onboarding/chat`);
              setisQuestLoading(false);
            }
          })
          .catch((error) => {
            setisQuestLoading(false);
            navigate(`/onboarding/chat`);
          });
      } else {
        nextQuestions(nextQuestionData)
          .then((res) => {
            if (isExist) {
              onSaveExitClick("assessment");
            }
            setcurrentQuestionInfo(res);
            setisQuestLoading(false);
            setnumberOfSequentialQuestionanswered((prev) => prev + 1);
          })
          .catch((error) => {
            setisErrorOnProp(true);
            // navigate(`/assessmentProgress/${"save"}`);
            // navigate(`/onboarding/chat`);
            setisQuestLoading(false);
          });
      }
    }
  };

  //function to call previous question
  const callPrevQuestions = (isExist = false) => {
    if (
      currentQuestionInfo?.categoryId === "" ||
      currentQuestionInfo?.categoryId === undefined ||
      currentQuestionInfo?.categoryId === null ||
      currentQuestionInfo?.currQuestion?.id === "" ||
      currentQuestionInfo?.currQuestion?.id === undefined ||
      currentQuestionInfo?.currQuestion?.id === null
    ) {
      setisErrorOnProp(true);
      return;
    }
    setisQuestLoading(true);

    const prevQuestionData = {
      item_id: currentQuestionInfo?.categoryId,
      item_type: "category",
      curr_question_num: currentQuestionInfo?.currQuestion?.number,
      is_survey: false,
    };
    prevQuestions(prevQuestionData)
      .then((res) => {
        setcurrentQuestionInfo(res);
        setisQuestLoading(false);
      })
      .catch((error) => {
        setisQuestLoading(false);
        setisErrorOnProp(true);
      })
      .finally(setisQuestLoading(false));
  };

  //function to call when user clicks on save and exit button
  const onSaveExitClick = (txt) => {
    navigate(`/onboarding/chat`);
  };

  return (
    <div className="assessment-hero-container">
      <div className="supressed-bg">
        <AssessmentContainer
          id={currentQuestionInfo?.currQuestion?.id}
          question={currentQuestionInfo?.instructions}
          description={currentQuestionInfo?.currQuestion?.description}
          options={currentQuestionInfo?.currQuestion?.optionsList}
          type={currentQuestionInfo?.currQuestion?.type}
          onSubmit={callNextQuestion}
          onPrev={callPrevQuestions}
          isFirstQuestion={currentQuestionInfo?.currQuestion?.number === 1}
          progressValue={currentQuestionInfo?.completionStatus}
          isSurvey={false}
          answerList={currentQuestionInfo?.answer}
          title={currentQuestionInfo?.categoryName}
          currentCategoryCount={
            currentQuestionInfo?.currQuestion?.categoryNumber
          }
          totalCategoryCount={
            currentQuestionInfo?.currQuestion?.categoryTotalCount
          }
          isQuestLoading={isQuestLoading}
          isErrorOnProp={isErrorOnProp}
          jump_to_prev={currentQuestionInfo?.jump_to_prev}
        />
      </div>
    </div>
  );
}

export default Assessments;
